<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <h1>{{ $t('menu.manager-list') }}</h1>
            <piaf-breadcrumb />
            <div class="separator mb-5" />
        </b-colxx>
    </b-row>

    <b-row class="mb-5">
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row>
                    <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
                        <v-select :options="searchOptions" v-model="searchKind"></v-select>
                    </b-colxx>
                    <b-colxx xxs="12" md="6" lg="4" xl="4">
                        <b-input-group class="mb-3">
                            <b-input v-model="searchKeyword" @keyup.enter="onSearch" /><!-- :placeholder="$t('menu.search')" -->
                            <b-input-group-append>
                                <b-button variant="outline-primary default" v-show="!searchFlag" @click="onSearch">
                                    {{$t('button.search')}}
                                </b-button>
                            </b-input-group-append>

                            <!--                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">-->
                            <!--                  {{$t('button.search')}}-->
                            <!--                </b-button>-->
                            <!--                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary" size="sm">-->
                            <!--                  {{$t('button.search-cancel')}}-->
                            <!--                </b-button>-->
                        </b-input-group>
                    </b-colxx>
                    <!--            <b-colxx xxs="2" md="2" lg="4">-->
                    <!--              <div class="float-md-right pt-1">-->
                    <!--                <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-primary" class="d-inline-block"-->
                    <!--                            size="md">-->
                    <!--                  <b-dropdown-item v-for="(size,index) in pageSizes" :key="index" @click="changePageSize(size)">{{ size}}-->
                    <!--                  </b-dropdown-item>-->
                    <!--                </b-dropdown>-->
                    <!--              </div>-->
                    <!--            </b-colxx>-->
                </b-row>

                <template v-if="isLoad">
                    <b-table head-variant="light" ref="general-table" class="vuetable" selectedVariant="primary" :items="items" :fields="fields" primary-key="settingId" responsive show-empty>
                        <template v-slot:cell(username)="row">
                            <router-link :to="`manager-detail/${row.item.username}`" class="cls_click">
                                {{row.item.username}}
                            </router-link>
                        </template>

                        <template v-slot:cell(phoneNumber)="row">
                            {{ row.item.phoneNumber.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`) }}
                        </template>
                        <template v-slot:cell(userRole)="row">
                            {{gradeOption.find(x => x.value == row.item.userRole).label}}
                        </template>

                        <template v-slot:cell(storeCode)="row">
                            {{row.item.storeCode !== null?
                (brandStoreCode.find(x => x.storeCode == row.item.storeCode) != null? brandStoreCode.find(x => x.storeCode == row.item.storeCode).storeName : '' ) :'' }}
                            <!--                {{row.item.storeCode !== null? brandStoreCode.find(x => x.storeCode == row.item.storeCode).storeName :'' }}-->

                        </template>

                        <template v-slot:cell(requestedDate)="row">
                            {{row.item.requestedDate.substr(0,10)}}
                        </template>

                        <template v-slot:empty>
                            <h4 style="text-align:center">조회된 내용이 없습니다.</h4>
                        </template>

                    </b-table>

                    <!--            <b-pagination v-if="lastPage > 1"-->
                    <!--                          size="sm"-->
                    <!--                          align="center"-->
                    <!--                          :total-rows="total"-->
                    <!--                          :per-page="perPage"-->
                    <!--                          v-model="currentPage"-->
                    <!--            >-->
                    <!--              <template v-slot:next-text>-->
                    <!--                <i class="simple-icon-arrow-right"/>-->
                    <!--              </template>-->
                    <!--              <template v-slot:prev-text>-->
                    <!--                <i class="simple-icon-arrow-left"/>-->
                    <!--              </template>-->
                    <!--              <template v-slot:first-text>-->
                    <!--                <i class="simple-icon-control-start"/>-->
                    <!--              </template>-->
                    <!--              <template v-slot:last-text>-->
                    <!--                <i class="simple-icon-control-end"/>-->
                    <!--              </template>-->
                    <!--            </b-pagination>-->

                    <!--            <div style="text-align: right">-->
                    <!--              <b-button class="mb-1" @click="register" variant="primary">등록</b-button>-->
                    <!--            </div>-->
                </template>
                <template v-else>
                    <div class="loading"></div>
                </template>

            </b-card>
        </b-colxx>
    </b-row>

</div>
</template>

<script>
import api from '../../constants/api'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import '../../assets/css/custom/common.css'
import {
    alignTableCenter
} from '../../utils'

import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            storeCodeLoad: false,
            isLoad: false,
            brandStoreCode: [],
            searchKind: {
                label: '전체',
                value: 'ALL'
            },
            searchOptions: [{
                    label: '전체',
                    value: 'ALL'
                },
                {
                    label: '운영자 ID',
                    value: 'username'
                },
                {
                    label: '운영자 이름',
                    value: 'fullName'
                },
            ],
            gradeOption: [{
                    label: '마스터',
                    value: 'BRAND_ADMIN'
                },
                // {label: '브랜드 관리자', value: 'BRAND_MANAGER'},
                // {label: '매장 운영자', value: 'STORE_OWNER'},
                {
                    label: '스토어 스탭',
                    value: 'STORE_MANAGER'
                }
            ],
            storeOptions: [],
            selectAll: false,
            items: [],
            fields: [{
                    key: 'key',
                    label: '번호',
                    ...alignTableCenter
                },
                {
                    key: 'username',
                    label: '운영자 ID',
                    ...alignTableCenter
                },
                {
                    key: 'fullName',
                    label: '운영자 이름',
                    ...alignTableCenter
                },
                {
                    key: 'phoneNumber',
                    label: '전화번호',
                    ...alignTableCenter
                },
                {
                    key: 'userRole',
                    label: '역할'
                },
                {
                    key: 'storeCode',
                    label: '관리매장'
                },
                {
                    key: 'requestedDate',
                    label: '권한 등록일'
                },
            ],
            searchFlag: false,
            selectedMemberId: null,
            pageSizes: [10, 20, 30],
            currentPage: 1,
            perPage: 10,
            searchKeyword: '',
            total: 15,
            lastPage: 2
        }
    },
    computed: {
        ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
        this.getBrandStoreCode()
        this.searchData()
    },
    watch: {
        selectAll(chk) {
            this.items.forEach(v => {
                v.selected = chk
            })
        },

        gradeOption(val) {
            console.log(val)
        }

    },
    methods: {

        //운영자 리스트 조회
        searchData() {
            this.items = []
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.user.list)

            this.$http.get(reqURL, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {

                    let _items = res.data.data.admins

                    _items.forEach((value, index) => {
                        value.key = index + 1;
                        if (value.userRole != "User" && value.approved) {
                            this.items.push(value)
                        }
                    });

                } else {
                    throw 400
                }
            }).catch(err => {})

            this.isLoad = true

        },

        //사이트 내 매장코드 리스트 조회
        async getBrandStoreCode() {
            this.brandStoreCode = []

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.brandStoreCode)

            await this.$http.get(reqURL).then(res => {
                if (res.data.code === "OK") {
                    ;
                    this.brandStoreCode = res.data.data
                } else {
                    throw 400
                }
            }).catch(err => {})
        },

        register() {},

        onSearch() {
            if (this.searchKeyword === "") {
                alert('검색어를 입력하세요');
                return false
            }
            // this.searchFlag = true;
            this.searchData();
        },
        searchCancel() {
            this.searchFlag = false;
            this.searchKeyword = '';
            this.searchData();
        },
        changePageSize(perPage) {
            this.perPage = perPage
        },
        changedItemCheck(row) {
            console.log(row)
        }
    }
}
</script>
